import { ReactNode } from 'react'
import { cn } from '@/lib/utils'

type Column<T> = {
  key: string
  header: string
  className?: string
  render: (item: T) => ReactNode
}

type DataTableProps<T> = {
  columns: Column<T>[]
  data: T[]
  keyFn: (item: T) => string
  emptyMessage?: string
  onRowClick?: (item: T) => void
}

export function DataTable<T>({ columns, data, keyFn, emptyMessage = 'Nothing here yet.', onRowClick }: DataTableProps<T>) {
  if (data.length === 0) {
    return (
      <div className="py-12 text-center">
        <p className="text-sm text-muted-foreground">{emptyMessage}</p>
      </div>
    )
  }

  return (
    <div className="w-full">
      {/* Header */}
      <div className="flex items-center border-b border-border/60 text-[12px] font-medium text-muted-foreground uppercase tracking-wider">
        {columns.map((col) => (
          <div key={col.key} className={cn("px-3 py-2", col.className)}>
            {col.header}
          </div>
        ))}
      </div>
      {/* Rows */}
      {data.map((item) => (
        <div
          key={keyFn(item)}
          className={cn(
            "flex items-center border-b border-border/40 last:border-0",
            onRowClick && "cursor-pointer hover:bg-muted/50 transition-colors"
          )}
          onClick={onRowClick ? () => onRowClick(item) : undefined}
        >
          {columns.map((col) => (
            <div key={col.key} className={cn("px-3 py-2.5", col.className)}>
              {col.render(item)}
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}
